import { IEvaluationService } from '../interfaces/evaluation-service.interface';

/**
 * No-Op EvaluationService für Apps ohne automatische Feldberechnungen.
 */
export class NullEvaluationService implements IEvaluationService {
	has(_key: string): boolean { return false; }
	evaluate(_key: string): string | number | undefined { return undefined; }
}
